import logo from './logo.svg';
import './App.css';
import Home from './Pages/Home';
import Navbar from './Pages/Navbar';
import { Route, Routes } from 'react-router-dom';
import AllProjects from './Pages/AllProjects';
import Blogs from './Pages/Blogs';


function App() {
  return (
    <div className="max-w-7xl px-12 mx-auto">
      <Navbar></Navbar>
      <Routes>
        <Route path='/home' element={<Home></Home>}></Route>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/projects' element={<AllProjects></AllProjects>}></Route>
        <Route path='/blogs' element={<Blogs></Blogs>}></Route>
      </Routes>
    </div>
  );
}

export default App;
